import useFiltersVariables from "components/Filters/useFiltersVariables";

import { INITIAL_SORT_DIRECTION, INITIAL_SORT_OPTION, TOFU_WORKSPACES_FILTER_TYPE } from "./constants";

const useTofuWorkspacesFiltersVariables = () => {
  const { filterVariables, filterVariablesLoaded } = useFiltersVariables({
    filterType: TOFU_WORKSPACES_FILTER_TYPE,
    initialSortDirection: INITIAL_SORT_DIRECTION,
    initialSortOption: INITIAL_SORT_OPTION,
  });

  return {
    fullTextSearch: filterVariables.searchInput,
    sortOptionFields: filterVariables.sortOptionFields,
    filterVariablesLoaded,
  };
};

export default useTofuWorkspacesFiltersVariables;
